import React from "react";
import i18next from "../../locale/i18n";

type ActiveTool = 'cut' | 'sew' | 'unfold' | null;

interface ButtonConfig {
    ref: React.RefObject<HTMLButtonElement>;
    label: string;
    tool: 'cut' | 'sew' | 'unfold';
}

interface MobileSideButtonsProps {
    position: 'left' | 'right';
    buttons: ButtonConfig[];
    activeTool: ActiveTool;
    onNext: () => void;
    goalsMet: boolean;
    // Stats
    edgeSeams?: number;
    seamsGoal?: number | null;
    globalStretchness?: number;
    stretchGoal?: number | null;
}

export function MobileSideButtons({
    position,
    buttons,
    activeTool,
    onNext,
    goalsMet,
    edgeSeams = 0,
    seamsGoal = null,
    globalStretchness = 0,
    stretchGoal = null
}: MobileSideButtonsProps) {
    const t = (key: string) => i18next.t(key);

    const getToolButtonClass = (tool: ActiveTool): string => {
        return activeTool === tool
            ? 'mobile-side-btn mobile-side-btn-active'
            : 'mobile-side-btn';
    };

    const getGoalColor = (current: number, goal: number | null): string => {
        if (goal === null) return 'inherit';
        return current <= goal ? 'var(--color-success)' : 'var(--color-error)';
    };

    return (
        <div className={`mobile-side-buttons mobile-side-buttons-${position}`}>
            <div className="mobile-side-stats">
                <div className="mobile-side-stat">
                    <span className="mobile-side-stat-label">{t('practice:seamCount')}</span>
                    <span
                        className="mobile-side-stat-value"
                        style={{ color: getGoalColor(edgeSeams, seamsGoal) }}
                    >
                        {edgeSeams}/{seamsGoal ?? '—'}
                    </span>
                </div>
                <div className="mobile-side-stat">
                    <span className="mobile-side-stat-label">{t('practice:stretch')}</span>
                    <span
                        className="mobile-side-stat-value"
                        style={{ color: getGoalColor(globalStretchness, stretchGoal) }}
                    >
                        {globalStretchness}/{stretchGoal ?? '—'}
                    </span>
                </div>
            </div>
            <div className="mobile-side-buttons-grid">
                {buttons.map((btn) => (
                    <button
                        key={btn.tool}
                        ref={btn.ref}
                        className={getToolButtonClass(btn.tool)}
                        aria-label={t(`practice:${btn.label}`)}
                    >
                        {t(`practice:${btn.label}`)}
                    </button>
                ))}
                <button
                    className={goalsMet ? "mobile-side-btn mobile-side-next" : "mobile-side-btn mobile-side-next mobile-side-btn-blocked"}
                    onClick={onNext}
                >
                    {t('practice:next')}
                </button>
            </div>
        </div>
    );
}
